<app-page-header [pageHeader]="pageHeader"></app-page-header>

<app-breadcrumb
  [artigo]="artigo"
  [tour]="tour"
  [articleNotFound]="articleNotFound"
  *ngIf="!isLoading"
></app-breadcrumb>

<div class="section-page">
  <div class="container">
    <div *ngIf="isLoading" class="loading-container">
      <div class="spinner"></div>
      <p>Carregando...</p>
    </div>
    <div *ngIf="!isLoading" class="content col-lg-8 col-12">
      <article class="" id="">
        <h2 class="hidden first" [hidden]="hideh2">
          Ops! Parece que este artigo foi removido.
        </h2>
        <h2 class="hidden second" [hidden]="hideh2">
          Experimente navegar pelas categorias ou usar outras palavras para
          encontrar o que procura.
        </h2>
        <a class="link-custom hidden" [hidden]="hideh2" href="/"
          >👉 Voltar para a Central de Ajuda</a
        >
        <h2>{{ artigo.titulo }}</h2>
        <div [innerHTML]="artigo.conteudo | noSanitize"></div>
      </article>
      <app-feedback *ngIf="artigo.conteudo" [idArticle]="artigo.id"></app-feedback>
    </div>
    <aside *ngIf="!hideaside && !isLoading" class="aside-menu col-lg-4">
      <app-more-articles
        *ngIf="!tourSequence"
        [moreArticles]="artigo.relacionados"
      ></app-more-articles>

      <app-tour-sequence
        *ngIf="tourSequence"
        [tour]="tour"
        [idArticle]="artigo.id"
      ></app-tour-sequence>
    </aside>
  </div>
</div>
